import { sql } from "drizzle-orm";
import { check, index, integer, real, sqliteTable, text } from "drizzle-orm/sqlite-core";

// ============================================================================
// sales_legacy_invoices_archive — retired sales invoice source table
// ============================================================================
export const salesInvoices = sqliteTable("sales_legacy_invoices_archive", {
  id: text("id").primaryKey(),
  invoiceNo: text("invoice_no").notNull().unique(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  invoiceType: text("invoice_type", {
    enum: ["sales", "purchase", "credit_note", "debit_note"],
  }).notNull().default("sales"),
  partyType: text("party_type", {
    enum: ["customer", "supplier"],
  }).notNull().default("customer"),
  partyId: text("party_id").notNull(),
  invoiceDate: text("invoice_date").notNull(),
  dueDate: text("due_date"),
  subtotal: real("subtotal").notNull().default(0),
  taxAmount: real("tax_amount").notNull().default(0),
  totalDiscount: real("total_discount").default(0),
  totalWht: real("total_wht").default(0),
  total: real("total").notNull().default(0),
  outstanding: real("outstanding").notNull().default(0),
  docStatus: integer("doc_status").notNull().default(0),
  status: text("status", {
    enum: ["draft", "submitted", "partially_paid", "paid", "overdue", "cancelled"],
  }).notNull().default("draft"),
  creditNoteOf: text("credit_note_of"),
  debitNoteOf: text("debit_note_of"),
  reason: text("reason"),
  originalInvoiceAmount: real("original_invoice_amount"),
  correctedAmount: real("corrected_amount"),
  differenceAmount: real("difference_amount"),
  reasonCode: text("reason_code", {
    enum: [
      "discount",
      "return",
      "price_error",
      "short_delivery",
      "excess_delivery",
      "quality_issue",
      "other",
    ],
  }),
  currencyCode: text("currency_code").default("THB"),
  exchangeRate: real("exchange_rate").default(1),
  transactionType: text("transaction_type"),
  deliveryDate: text("delivery_date"),
  taxPointDate: text("tax_point_date"),
  vatStatus: text("vat_status", {
    enum: ["undue", "due", "reported", "exempt"],
  }).default("due"),
  vatPeriod: text("vat_period"),
  remarks: text("remarks"),
  referenceModule: text("reference_module"),
  referenceDoctype: text("reference_doctype"),
  referenceId: text("reference_id"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyStatusIdx: index("slia_company_status_idx").on(table.companyId, table.status, table.invoiceDate),
  companyPartyIdx: index("slia_company_party_idx").on(table.companyId, table.partyType, table.partyId),
  companyTypeIdx: index("slia_company_type_idx").on(table.companyId, table.invoiceType, table.status),
  companyBranchIdx: index("slia_company_branch_idx").on(table.companyId, table.branchId, table.status),
  creditNoteOfIdx: index("slia_credit_note_of_idx").on(table.creditNoteOf),
  debitNoteOfIdx: index("slia_debit_note_of_idx").on(table.debitNoteOf),
  companyVatPeriodIdx: index("slia_company_vat_period_idx").on(table.companyId, table.vatPeriod, table.vatStatus),
  companyTaxPointIdx: index("slia_company_tax_point_idx").on(table.companyId, table.taxPointDate, table.vatStatus),
  ownerCheck: check("sales_legacy_invoices_archive_owner_chk", sql`${table.invoiceType} = 'sales' AND ${table.partyType} = 'customer'`),
}));

// ============================================================================
// sales_legacy_credit_notes_archive — retired sales credit-note source table
// ============================================================================
export const salesCreditNotes = sqliteTable("sales_legacy_credit_notes_archive", {
  id: text("id").primaryKey(),
  invoiceNo: text("invoice_no").notNull().unique(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  invoiceType: text("invoice_type", {
    enum: ["sales", "purchase", "credit_note", "debit_note"],
  }).notNull().default("credit_note"),
  partyType: text("party_type", {
    enum: ["customer", "supplier"],
  }).notNull().default("customer"),
  partyId: text("party_id").notNull(),
  invoiceDate: text("invoice_date").notNull(),
  dueDate: text("due_date"),
  subtotal: real("subtotal").notNull().default(0),
  taxAmount: real("tax_amount").notNull().default(0),
  totalDiscount: real("total_discount").default(0),
  totalWht: real("total_wht").default(0),
  total: real("total").notNull().default(0),
  outstanding: real("outstanding").notNull().default(0),
  docStatus: integer("doc_status").notNull().default(0),
  status: text("status", {
    enum: ["draft", "submitted", "partially_paid", "paid", "overdue", "cancelled"],
  }).notNull().default("draft"),
  creditNoteOf: text("credit_note_of"),
  debitNoteOf: text("debit_note_of"),
  reason: text("reason"),
  originalInvoiceAmount: real("original_invoice_amount"),
  correctedAmount: real("corrected_amount"),
  differenceAmount: real("difference_amount"),
  reasonCode: text("reason_code", {
    enum: [
      "discount",
      "return",
      "price_error",
      "short_delivery",
      "excess_delivery",
      "quality_issue",
      "other",
    ],
  }),
  currencyCode: text("currency_code").default("THB"),
  exchangeRate: real("exchange_rate").default(1),
  transactionType: text("transaction_type"),
  deliveryDate: text("delivery_date"),
  taxPointDate: text("tax_point_date"),
  vatStatus: text("vat_status", {
    enum: ["undue", "due", "reported", "exempt"],
  }).default("due"),
  vatPeriod: text("vat_period"),
  remarks: text("remarks"),
  referenceModule: text("reference_module"),
  referenceDoctype: text("reference_doctype"),
  referenceId: text("reference_id"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyStatusIdx: index("slcna_company_status_idx").on(table.companyId, table.status, table.invoiceDate),
  companyPartyIdx: index("slcna_company_party_idx").on(table.companyId, table.partyType, table.partyId),
  companyTypeIdx: index("slcna_company_type_idx").on(table.companyId, table.invoiceType, table.status),
  companyBranchIdx: index("slcna_company_branch_idx").on(table.companyId, table.branchId, table.status),
  creditNoteOfIdx: index("slcna_credit_note_of_idx").on(table.creditNoteOf),
  debitNoteOfIdx: index("slcna_debit_note_of_idx").on(table.debitNoteOf),
  companyVatPeriodIdx: index("slcna_company_vat_period_idx").on(table.companyId, table.vatPeriod, table.vatStatus),
  companyTaxPointIdx: index("slcna_company_tax_point_idx").on(table.companyId, table.taxPointDate, table.vatStatus),
  ownerCheck: check("sales_legacy_credit_notes_archive_owner_chk", sql`${table.invoiceType} = 'credit_note' AND ${table.partyType} = 'customer'`),
}));

// ============================================================================
// sales_legacy_debit_notes_archive — retired sales debit-note source table
// ============================================================================
export const salesDebitNotes = sqliteTable("sales_legacy_debit_notes_archive", {
  id: text("id").primaryKey(),
  invoiceNo: text("invoice_no").notNull().unique(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  invoiceType: text("invoice_type", {
    enum: ["sales", "purchase", "credit_note", "debit_note"],
  }).notNull().default("debit_note"),
  partyType: text("party_type", {
    enum: ["customer", "supplier"],
  }).notNull().default("customer"),
  partyId: text("party_id").notNull(),
  invoiceDate: text("invoice_date").notNull(),
  dueDate: text("due_date"),
  subtotal: real("subtotal").notNull().default(0),
  taxAmount: real("tax_amount").notNull().default(0),
  totalDiscount: real("total_discount").default(0),
  totalWht: real("total_wht").default(0),
  total: real("total").notNull().default(0),
  outstanding: real("outstanding").notNull().default(0),
  docStatus: integer("doc_status").notNull().default(0),
  status: text("status", {
    enum: ["draft", "submitted", "partially_paid", "paid", "overdue", "cancelled"],
  }).notNull().default("draft"),
  creditNoteOf: text("credit_note_of"),
  debitNoteOf: text("debit_note_of"),
  reason: text("reason"),
  originalInvoiceAmount: real("original_invoice_amount"),
  correctedAmount: real("corrected_amount"),
  differenceAmount: real("difference_amount"),
  reasonCode: text("reason_code", {
    enum: [
      "discount",
      "return",
      "price_error",
      "short_delivery",
      "excess_delivery",
      "quality_issue",
      "other",
    ],
  }),
  currencyCode: text("currency_code").default("THB"),
  exchangeRate: real("exchange_rate").default(1),
  transactionType: text("transaction_type"),
  deliveryDate: text("delivery_date"),
  taxPointDate: text("tax_point_date"),
  vatStatus: text("vat_status", {
    enum: ["undue", "due", "reported", "exempt"],
  }).default("due"),
  vatPeriod: text("vat_period"),
  remarks: text("remarks"),
  referenceModule: text("reference_module"),
  referenceDoctype: text("reference_doctype"),
  referenceId: text("reference_id"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyStatusIdx: index("sldna_company_status_idx").on(table.companyId, table.status, table.invoiceDate),
  companyPartyIdx: index("sldna_company_party_idx").on(table.companyId, table.partyType, table.partyId),
  companyTypeIdx: index("sldna_company_type_idx").on(table.companyId, table.invoiceType, table.status),
  companyBranchIdx: index("sldna_company_branch_idx").on(table.companyId, table.branchId, table.status),
  creditNoteOfIdx: index("sldna_credit_note_of_idx").on(table.creditNoteOf),
  debitNoteOfIdx: index("sldna_debit_note_of_idx").on(table.debitNoteOf),
  companyVatPeriodIdx: index("sldna_company_vat_period_idx").on(table.companyId, table.vatPeriod, table.vatStatus),
  companyTaxPointIdx: index("sldna_company_tax_point_idx").on(table.companyId, table.taxPointDate, table.vatStatus),
  ownerCheck: check("sales_legacy_debit_notes_archive_owner_chk", sql`${table.invoiceType} = 'debit_note' AND ${table.partyType} = 'customer'`),
}));

export type SalesInvoice = typeof salesInvoices.$inferSelect;
export type NewSalesInvoice = typeof salesInvoices.$inferInsert;
export type SalesCreditNote = typeof salesCreditNotes.$inferSelect;
export type NewSalesCreditNote = typeof salesCreditNotes.$inferInsert;
export type SalesDebitNote = typeof salesDebitNotes.$inferSelect;
export type NewSalesDebitNote = typeof salesDebitNotes.$inferInsert;
